export default __webpack_public_path__ + "static/media/blog-img240.9823867f.jpg";